import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { CombineInputGroup, Label } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Images from "../../Images";

const EditStayRulesModal = ({ onClose, initialValues = {}, onSave }) => {
  const defaultValues = {
    rentCycle: initialValues.rentCycle || "",
    dailyCharges: initialValues.dailyCharges || "",
    lockInPeriod: initialValues.lockInPeriod || "",
    noticePeriod: initialValues.noticePeriod || "",
    agreementDuration: initialValues.agreementDuration || "",
    checkInTime: initialValues.checkInTime || "",
    checkOutTime: initialValues.checkOutTime || "",
  };

  return (
    <div className="bg-white w-full h-full flex flex-col">
      <div className="flex items-center justify-between bg-[#0078BD] py-6 px-4">
        <Title className="text-white">Edit Renting & Stay Rules</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>

      <Formik
        initialValues={defaultValues}
        validationSchema={Yup.object({
          rentCycle: Yup.string().required("Required"),
          dailyCharges: Yup.string().required("Required"),
          lockInPeriod: Yup.string().required("Required"),
          noticePeriod: Yup.string().required("Required"),
        })}
        onSubmit={(values) => {
          onSave(values);
          onClose();
        }}
      >
        {({ values, handleChange, errors, touched }) => (
          <Form className="px-4 h-full flex flex-col justify-between py-4 relative">
            <Wrapper>
              <Section>
                <SectionTitle>Renting Terms</SectionTitle>
                <InputGroup>
                  <Label>Rent Addition Cycle</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="rentCycle"
                      value={values.rentCycle}
                      onChange={handleChange}
                    />
                    {touched.rentCycle && errors.rentCycle && (
                      <Error>{errors.rentCycle}</Error>
                    )}
                  </FieldWrapper>
                </InputGroup>
              </Section>

              <Section>
                <SectionTitle>Stay Terms</SectionTitle>
                <CombineInputGroup>
                  <InputGroup>
                    <Label>Daily Charges (₹)</Label>
                    <FieldWrapper>
                      <Input
                        type="text"
                        name="dailyCharges"
                        value={values.dailyCharges}
                        onChange={handleChange}
                      />
                      {touched.dailyCharges && errors.dailyCharges && (
                        <Error>{errors.dailyCharges}</Error>
                      )}
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="lockInPeriod">
                      Lock-in Period (Months)
                    </Label>
                    <FieldWrapper>
                      <Select
                        id="lockInPeriod"
                        name="lockInPeriod"
                        className="w-full pl-2"
                        value={values.lockInPeriod}
                        onChange={handleChange}
                      >
                        {[...Array(24).keys()].map((num) => {
                          const value = (num + 1) * 0.5;
                          return (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.lockInPeriod && errors.lockInPeriod && (
                        <Error>{errors.lockInPeriod}</Error>
                      )}
                    </FieldWrapper>
                  </InputGroup>
                </CombineInputGroup>

                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="noticePeriod">Notice Period (Months)</Label>
                    <FieldWrapper>
                      <Select
                        id="noticePeriod"
                        name="noticePeriod"
                        className="w-full pl-2"
                        value={values.noticePeriod}
                        onChange={handleChange}
                      >
                        {[...Array(24).keys()].map((num) => {
                          const value = (num + 1) * 0.5;
                          return (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.noticePeriod && errors.noticePeriod && (
                        <Error>{errors.noticePeriod}</Error>
                      )}
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label>Agreement Period (Months)</Label>
                    <FieldWrapper>
                      <Select
                        id="agreementPeriod"
                        name="agreementPeriod"
                        className="w-full pl-2"
                        value={values.agreementPeriod}
                        onChange={handleChange}
                      >
                        {[...Array(24).keys()].map((num) => {
                          const value = (num + 1) * 0.5;
                          return (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.agreementPeriod && errors.agreementPeriod && (
                        <Error>{errors.agreementPeriod}</Error>
                      )}
                    </FieldWrapper>
                  </InputGroup>
                </CombineInputGroup>

                <CombineInputGroup>
                  <InputGroup>
                    <Label>Moved In</Label>
                    <FieldWrapper className="relative">
                      <Input
                        type="date"
                        name="moveInDate"
                        id="moveInDate"
                        className="pl-7"
                        value={values.moveInDate}
                        onChange={handleChange}
                      />
                      {touched.moveInDate && errors.moveInDate && (
                        <Error>{errors.moveInDate}</Error>
                      )}
                      <img
                        src={Images.Calender}
                        alt="Calendar icon"
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
                      />
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label>Moved Out</Label>
                    <FieldWrapper className="relative">
                      <Input
                        type="date"
                        name="moveOutDate"
                        id="moveOutDate"
                        className="pl-7"
                        value={values.moveOutDate}
                        onChange={handleChange}
                      />
                      {touched.moveOutDate && errors.moveOutDate && (
                        <Error>{errors.moveOutDate}</Error>
                      )}
                      <img
                        src={Images.Calender}
                        alt="Calendar icon"
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 cursor-pointer"
                      />
                    </FieldWrapper>
                  </InputGroup>
                </CombineInputGroup>
              </Section>
            </Wrapper>

            <BtnWrapper>
              <SecondaryButton type="button" onClick={onClose}>
                Cancel
              </SecondaryButton>
              <PrimaryButton type="submit">Update</PrimaryButton>
            </BtnWrapper>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const InputGroup = tw.div`w-full flex flex-col space-y-1.5 mb-2`;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-800 mb-2`;
const Error = tw.p`text-rose-600 text-sm`;
const BtnWrapper = tw.div`flex gap-3`;
const PrimaryButton = tw.button`bg-[#0078BD] w-1/2 text-white px-4 py-2 rounded-lg hover:bg-[#65adf0]`;
const SecondaryButton = tw.button`bg-white border w-1/2 border-[#0078BD] text-[#0078BD] font-medium px-4 py-1 rounded-lg`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditStayRulesModal;
